import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { MapboxGeoJSONFeature } from 'mapbox-gl';
import { neutral } from '../../../style/colors';
import { ChevronDown } from '../../common/Icons/Light';
import { useSpring, animated } from 'react-spring';
import Detaljer from './Detaljer';
import { IAppState } from '../../../store/interfaces/state';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
const LokalplanListItem = (props: ILokalplanListItemPropType) => {
  const [expanded, setExpanded] = useState(false);
  const {
    feature,
    onHover,
    othersAreHovered,
    isHovered,
    accentColor,
    bgColor,
    clickedByggefelt,
    clickedDelomraade,
  } = props;
  const { properties } = feature;
  const { delnr = undefined, planid = undefined } = properties || {};
  useEffect(() => {
    if (planid === clickedByggefelt || planid === clickedDelomraade) {
      setExpanded(true);
    }
  }, [clickedByggefelt, clickedDelomraade, planid]);
  const ref = useRef(null);
  useEffect(() => {
    if (isHovered) {
      setTimeout(() => {
        scrollIntoView(ref.current, {
          scrollMode: 'if-needed',
          behavior: 'smooth',
          block: 'nearest',
        });
      }, 100);
    }
  }, [isHovered]);
  const upsideDown = useSpring({
    transform: expanded ? 'rotateX(180deg)' : 'rotateX(0deg)',
  });

  return (
    <Wrapper ref={ref} isHovered={isHovered} accentColor={accentColor} expanded={expanded}>
      <Item
        othersAreHovered={othersAreHovered}
        isHovered={isHovered}
        expanded={expanded}
        accentColor={accentColor}
        onMouseOver={onHover ? () => onHover([planid]) : () => { }}
        onClick={() => setExpanded(!expanded)}
        onMouseOut={onHover ? () => onHover([-1]) : () => { }}
      >
        {delnr}
        <animated.div
          style={{
            ...{
              height: 18,
              padding: '0 0.5em',
              marginLeft: 'auto',
            },
            ...upsideDown,
          }}
        >
          <ChevronDown width={18} />
        </animated.div>
      </Item>
      <Detaljer
        plan={feature}
        accentColor={accentColor}
        bgColor={bgColor}
        show={expanded}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 5px 0 15px 0;
  position: relative;
  overflow:hidden;
  &::after {
    position: absolute;
    left: 0;
    bottom: 2px;
    content: '';
    display: block;
    width: 4px;
    height: 100%;
    background-color: transparent;
    z-index: 10;
  }
  ${props =>
    (props.isHovered || props.expanded) &&
    css`
      &::after {
        background-color: ${props.accentColor};
      }  
    `}
`;

const Item = styled.div`
  display: flex;
  cursor: pointer;
  background-color: #ffffff;
  padding: 3px 12px;
  height: 45px;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #D3DEE8;
  
  ${props =>
    props.othersAreHovered &&
    css`
      color: ${neutral[400]};
    `}
  ${props =>
    (props.isHovered || props.expanded) &&
    css`
      color: ${props.accentColor};
    `}
  ${props =>
    props.expanded &&
    css`
      margin-bottom: 0;
      border-bottom: 2px solid #F0F4F8;
    `}

`;

const mapStateToProps = (state: IAppState) => {
  const { clickedPlan } = state;
  return {
    clickedDelomraade: clickedPlan.delomraade,
    clickedByggefelt: clickedPlan.byggefelt,
  };
};

interface ILokalplanListItemPropType {
  feature: MapboxGeoJSONFeature;
  accentColor: string;
  bgColor: string;
  onClick?: Function;
  onHover?: Function;
  isHovered: boolean;
  othersAreHovered: boolean;
  clickedDelomraade: number;
  clickedByggefelt: number;
}

export const PureLokalplanListItem = LokalplanListItem; // Til brug i storybook
export default connect(
  mapStateToProps,
  null
)(LokalplanListItem);
